import CityPageTemplate from "../city-template/CityPageTemplate";
import { fortWorthConfig } from "./data";

export default function FortWorthPage() {
  return <CityPageTemplate config={fortWorthConfig} />;
}